module.exports = __webpack_public_path__ + "static/media/auric-oak-logo.89faaf32.svg";


//////////////////
// WEBPACK FOOTER
// ./src/main/assets/images/logos/auric-oak-logo.svg
// module id = 81
// module chunks = 0